const _excluded = ["className", "width", "height", "as"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import cn from 'classnames';
import { Skeleton as SkeletonCore } from '@material-ui/lab';
import { makeStyles } from '@material-ui/styles';
import colors from "../../foundations/colors.module.scss";
const useStyles = makeStyles({
  root: {
    backgroundColor: colors.dark100
  },
  text: {
    transformOrigin: 'unset',
    transform: 'unset',
    borderRadius: '4px',
    marginTop: 'unset',
    marginBottom: 'unset'
  },
  wave: {
    '&::after': {
      background: "linear-gradient(90deg, transparent, ".concat(colors.dark70, ", transparent);")
    }
  }
});
export function Skeleton(_ref) {
  let {
      className,
      width,
      height,
      as = 'div'
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const overrides = useStyles();
  return /*#__PURE__*/React.createElement(SkeletonCore, _extends({
    width: width,
    height: height,
    component: as,
    className: cn(overrides.root, overrides.text, overrides.wave, className),
    animation: "wave",
    variant: "text"
  }, rest));
}